/**
 * Stripe is dormant unless REACT_APP_STRIPE_ENABLED is exactly "true".
 * Set in .env.local when you are ready to create customers and open checkout.
 */
export const isStripeBillingEnabled = () =>
  String(process.env.REACT_APP_STRIPE_ENABLED || '')
    .trim()
    .toLowerCase() === 'true';

/** Stripe Payment Link (Pro) — override with REACT_APP_STRIPE_PRO_PAYMENT_LINK */
const DEFAULT_PRO_PAYMENT_LINK =
  'https://buy.stripe.com/6oUaEX2W8ac8eTw37Ce3e00';

/** Stripe Payment Link (Enterprise) — override with REACT_APP_STRIPE_ENTERPRISE_PAYMENT_LINK */
const DEFAULT_ENTERPRISE_PAYMENT_LINK =
  'https://buy.stripe.com/bJe8wP54gckg4eS8rWe3e01';

export const getStripeProPaymentUrl = () => {
  const fromEnv = String(process.env.REACT_APP_STRIPE_PRO_PAYMENT_LINK || '').trim();
  return fromEnv || DEFAULT_PRO_PAYMENT_LINK;
};

export const getStripeEnterprisePaymentUrl = () => {
  const fromEnv = String(
    process.env.REACT_APP_STRIPE_ENTERPRISE_PAYMENT_LINK || ''
  ).trim();
  return fromEnv || DEFAULT_ENTERPRISE_PAYMENT_LINK;
};
